import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Group, UserOrgMembershipGroup } from '@models/membership';
import {
  ComboboxComponent,
  ComboboxOptionComponent,
  ErrorTextComponent,
  FormControlComponent,
  FormControlErrorDirective,
  HStackComponent,
  LabelComponent,
  SpinnerComponent,
} from '@mx51/chameleon-ui-angular';

@Component({
  selector: 'sd-access-type-select',
  templateUrl: './access-type-select.component.html',
  styleUrls: ['./access-type-select.component.scss'],
  standalone: true,
  imports: [
    FormControlComponent,
    LabelComponent,
    HStackComponent,
    ComboboxComponent,
    ComboboxOptionComponent,
    SpinnerComponent,
    ErrorTextComponent,
    FormControlErrorDirective,
    NgIf,
    NgFor,
  ],
})
export class AccessTypeSelectComponent implements OnChanges {
  @Input() isMultiple: boolean = true;
  @Input() allGroups: Group[] = null;
  @Input() selectedGroups: UserOrgMembershipGroup[] = [];
  @Input() selectFormControl: FormControl<string | string[] | null>;
  @Input() required = false;
  @Input() showError = false;
  options: { text: string; value: string }[] = [];
  value: string | string[] = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.allGroups?.currentValue) {
      const groups = changes.allGroups.currentValue ?? [];
      this.options = groups.map((group) => ({
        text: group.name,
        value: group.id,
      }));

      if (this.options.length > 0) {
        this.selectFormControl.enable();
      } else {
        this.selectFormControl.disable();
      }

      if (this.selectedGroups.length > 0) {
        const controlValue = this.isMultiple
          ? this.selectedGroups.map((group) => group.id)
          : this.selectedGroups[0]?.id;

        this.selectFormControl.setValue(controlValue);
      }
    }
  }

  handleAccessChange(value) {
    this.selectFormControl.setValue(value);
  }
}
